import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { c as MenuItems$1 } from '../../reach-menu-button.esm-22bcdd5f.js';
import { themed } from '@indeed/ifl-css';
import { StyledMenuItem } from './MenuItem.js';
import { jsx } from '@emotion/react';
import '../../reach-popover.esm-c19739dd.js';
import 'react-dom';
import 'focus-visible';
import '../../utils/styled.js';

const widths = {
  auto: 96,
  default: 198
};
const StyledMenuItems = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["isMobile", "menuWidth"],
  shouldForwardProp: prop => prop !== "isMobile" && prop !== "menuWidth",
  target: "e1o7jwm50"
} : {
  styleProps: ["isMobile", "menuWidth"],
  shouldForwardProp: prop => prop !== "isMobile" && prop !== "menuWidth",
  target: "e1o7jwm50",
  label: "StyledMenuItems"
})(_ref => {
  let {
    isMobile = false,
    menuWidth = "default"
  } = _ref;
  return [
  // Desktop styles
  {
    bg: "background",
    borderColor: "border",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "md",
    boxShadow: "medium",
    color: "foreground.strong",
    display: "flex",
    flexDirection: "column",
    fontFamily: "default",
    lineHeight: "normal",
    maxBlockSize: 264,
    minInlineSize: widths[menuWidth],
    marginBlockStart: 1,
    marginBlockEnd: 1,
    overflowX: "hidden",
    overflowY: "hidden",
    ":focus": {
      outline: "none"
    },
    [`${StyledMenuItem}`]: {
      ":first-of-type": {
        borderTopLeftRadius: "md",
        borderTopRightRadius: "md"
      },
      ":last-of-type": {
        borderBottomLeftRadius: "md",
        borderBottomRightRadius: "md"
      }
    }
  },
  // Mobile styles
  isMobile && {
    borderTopLeftRadius: "lg",
    borderTopRightRadius: "lg",
    borderBottomLeftRadius: "none",
    borderBottomRightRadius: "none",
    borderWidth: 0,
    boxShadow: "mobilePopover",
    maxBlockSize: "80vh",
    marginBlockStart: 0,
    marginBlockEnd: 0,
    [`${StyledMenuItem}`]: {
      ":first-of-type": {
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none"
      },
      ":last-of-type": {
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none"
      }
    }
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @deprecated The `Menu` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

// Using this method of styling the Reach MenuItem due to a prop error
// of "React does not recognize the `isMobile` prop" when trying to use
// the ".withComponent" method.
const MenuItems = /*#__PURE__*/forwardRef((props, ref) => jsx(StyledMenuItems, _extends({
  as: MenuItems$1,
  ref: ref
}, props)));
const MENU_ITEMS_WIDTHS = Object.keys(widths);
MenuItems.displayName = "MenuItems";

export { MENU_ITEMS_WIDTHS, MenuItems, StyledMenuItems };
